import { render } from "./BankAccountTxns.vue?vue&type=template&id=169118dc&scoped=true"
import script from "./BankAccountTxns.vue?vue&type=script&lang=js"
export * from "./BankAccountTxns.vue?vue&type=script&lang=js"

import "./BankAccountTxns.vue?vue&type=style&index=0&id=169118dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169118dc"]])

export default __exports__